module.exports = __webpack_public_path__ + "static/img/content.62a6d40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/floor6/content.png
// module id = db38
// module chunks = 2